export default {
  canvasWidth: 800,
  canvasHeight: 480,
  zoomStops: [50, 100, 200, 400],
  defaultZoom: 100,
};



// WEBPACK FOOTER //
// ./src/config/view.js